// Page teamMember
$(document).ready(function() {
	let $controlPlus = $('.teamMember a.controlPlus');
	let $controlMinus = $('.teamMember a.controlMinus');

	if (!$controlPlus.length || !$controlMinus.length) {
		return;
	}

	$controlPlus.click(function () {
		let $this = $(this);

		$('.teamMember').removeClass('expanded');
		$this.parents('.teamMember').addClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.teamMember').offset().top - 10,
		}, 700);

		return false;
	});

	$controlMinus.click(function () {
		let $this = $(this);

		$('.teamMember').removeClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.teamMember').offset().top - 10,
		}, 700);

		return false;
	});
});
